import * as App from '../../app';
import * as SDK from '../../lib/sdk';
import { setLang } from '../../translate';
var currentLang = 'ru';
export function initTranslate() {
    SDK.getLangSafe().then(function (lang) {
        setTimeout(function () {
            var _a;
            if (lang !== currentLang) {
                setLang(lang);
                App.emit('lang', lang);
                currentLang = lang;
            }
            App.stat.params({ lang: (_a = {}, _a[lang] = 1, _a) });
        }, 1);
    });
    if (DEVELOPMENT) {
        // @ts-ignore
        window['setLanguage'] = function (lang) {
            setLang(lang);
            App.emit('lang', lang);
            currentLang = lang;
        };
    }
}
